import React, { ReactElement, ReactNode } from "react";
import classnames from "classnames";

export interface ISubSectionProps {
    children?: ReactNode | ReactNode[];
    className?: string;
    testId?: string;
}

const subSection = ({ children, className, testId }: ISubSectionProps): ReactElement => {
    return (
        <div
            className={classnames("form-sub-section", className)}
            {...(testId ? { "data-testid": testId } : {})}
        >
            {children}
        </div>
    );
};

export default subSection;
